import React from 'react'
import Title from '../../components/typography/title.component'
import styled from 'styled-components'
import Container from '../../components/layout/container.component'
import { GRAY } from '../../styles/colors.style'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { redefinePassword } from './services/redefine-password.service'
import { bindActionCreators } from 'redux'
import { RedefinePasswordForm } from './components/redefine-password-form.component'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { StorageService } from '../../services'
import { userActions } from '../../actions'
import { toastActions } from '../../actions/toast.actions'
import { typeChangePassword } from '../../constants/type-change-password.constants'
import { jwtDecode } from 'jwt-decode'

const StyledPage = styled.div`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 4.6rem;

	p {
		text-align: center;
	}

	a {
		color: ${GRAY};
	}
`

class RedefinePasswordPage extends React.Component {
	state = {
		isValid: null,
		error: null,
		userId: null,
		code: null,
		isSubmitted: false,
		title: null,
		showRedirectModal: false,
		redirectCountdown: 10,
		redirectTimeoutId: null,
	}

	componentWillMount() {
		const { logout, showLoading } = this.props
		logout()
		showLoading()
	}

	componentDidMount() {
		const { hideLoading, match, location } = this.props
		const userId = match.params && match.params.id
		const params = new URLSearchParams(location.search)
		const code = params.get('code')
		const title = params.get('title')

		if (!userId || !code) {
			this.setState({ isValid: false }, () => hideLoading())
			return
		}

		this.setState({ isValid: true, userId, code, title }, () => hideLoading())
	}

	submit = (values, actions) => {
		const { showLoading, hideLoading } = this.props
		const { userId, code } = this.state
		showLoading()

		redefinePassword(userId, code, values.password)
			.then(async ({ data }) => {
				const isSuccess = data.success === true

				if (isSuccess) {
					await this.handleSuccessfulAuthentication(data.data)
				}

				this.setState(
					{
						isSubmitted: true,
						isValid: isSuccess,
						error:
							!isSuccess && data.errors && data.errors.length > 0
								? data.errors[0]
								: null,
					},
					() => hideLoading()
				)
			})
			.catch(({ response }) => {
				const fallbackError =
					response &&
					response.data &&
					response.data.errors &&
					response.data.errors.length > 0
						? response.data.errors[0]
						: 'Erro ao redefinir senha'

				this.setState(
					{
						isSubmitted: true,
						isValid: false,
						error: fallbackError,
					},
					() => hideLoading()
				)
			})
	}

	handleSuccessfulAuthentication = async (user) => {
		const { userLogin, setAccessToken, hideLoading, warning, success } = this.props
	
		try {
			const { accessToken } = user
			if (!accessToken) throw new Error('Token inválido')
	
			const payload = jwtDecode(accessToken)
	
			const roles = Array.isArray(payload.role)
				? payload.role
				: payload.role
				? [payload.role]
				: []
	
			const userData = {
				...user,
				roles,
				isRequester: roles.includes('Requester'),
			}
	
			setAccessToken(accessToken)
			userLogin(userData)
			StorageService.authentication.user.set(userData)
	
			success({ message: 'Login realizado com sucesso' })
	
			this.setState(
				{
					showRedirectModal: true,
					redirectCountdown: 5,
				},
				() => {
					const countdownInterval = setInterval(() => {
						this.setState((prev) => {
							if (prev.redirectCountdown === 1) {
								clearInterval(countdownInterval)
								this.props.history.push('/cliente/minhas-compras')
							}
							return { redirectCountdown: prev.redirectCountdown - 1 }
						})
					}, 1000)
	
					this.setState({ redirectTimeoutId: countdownInterval })
				}
			)
		} catch (err) {
			console.error('Erro ao autenticar automaticamente:', err)
			warning('Não foi possível autenticar automaticamente.')
			hideLoading()
		}
	}
	

	handleConfirmRedirect = () => {
		clearInterval(this.state.redirectTimeoutId)
		this.props.history.push('/cliente/minhas-compras')
	}

	handleCancelRedirect = () => {
		clearInterval(this.state.redirectTimeoutId)
		this.setState({ showRedirectModal: false })
	}

	renderForm = () => (
		<div>
			<Title>
				{this.state.title === typeChangePassword.EMAIL_CONFIRMATION
					? 'Defina sua senha'
					: 'Altere a sua senha'}
			</Title>
			<RedefinePasswordForm
				onSubmit={this.submit}
				title={this.state.title}
			/>
		</div>
	)

	renderSuccess = () => {
		const { history } = this.props
		return (
			<div>
				<Title>
					Senha alterada <br />
					<span className="bold">com sucesso</span>
				</Title>
				<p>
					<span className="bold">
						<a
							href=""
							onClick={(e) => {
								e.preventDefault()
								history.push(routes.ENTRAR)
							}}>
							Clique aqui
						</a>{' '}
					</span>
					para entrar em sua conta
				</p>
			</div>
		)
	}

	renderError = (error) => (
		<div>
			<Title>
				Redefinição de senha <br />
				<span className="bold">inválida</span>
			</Title>
			{error ? (
				<p>{error}</p>
			) : (
				<p>
					Link de redefinição inválido ou token expirado <br />
					Ao tentar entrar na sua conta você pode solicitar uma nova
					redefinição de senha
				</p>
			)}
		</div>
	)

	renderResponse = () => {
		const { isValid, isSubmitted, error } = this.state

		if (isValid == null) return null
		if (isSubmitted && isValid) return this.renderSuccess()
		if (isSubmitted && !isValid) return this.renderError(error)
		return this.renderForm()
	}

	render() {
		const { showRedirectModal, redirectCountdown } = this.state

		return (
			<StyledPage>
				<Container>{this.renderResponse()}</Container>

				{showRedirectModal && (
					<div
						style={{
							position: 'fixed',
							top: 0,
							left: 0,
							width: '100vw',
							height: '100vh',
							backgroundColor: 'rgba(0, 0, 0, 0.6)',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							zIndex: 1000,
						}}>
						<div
							style={{
								backgroundColor: '#fff',
								padding: '2rem',
								borderRadius: '16px',
								boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
								textAlign: 'center',
								width: '90%',
								maxWidth: '420px',
								fontFamily: 'Arial, sans-serif',
							}}>
							<h3 style={{ marginBottom: '1rem' }}>
								Senha redefinida com sucesso!
							</h3>
							<p
								style={{
									color: '#555',
									fontSize: '14px',
									marginBottom: '8px',
								}}>
								Você será redirecionado para <b>Minhas Compras</b> em{' '}
								<strong>{redirectCountdown}s</strong>
							</p>
							<p
								style={{
									fontSize: '13px',
									marginBottom: '1.5rem',
								}}>
								Caso não seja redirecionado,{' '}
								<a href="#" onClick={this.handleConfirmRedirect}>
									clique aqui
								</a>
								.
							</p>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									gap: '10px',
								}}>
								<button
									style={{
										backgroundColor: '#007bff',
										color: '#fff',
										padding: '10px 20px',
										border: 'none',
										borderRadius: '8px',
										cursor: 'pointer',
									}}
									onClick={this.handleConfirmRedirect}>
									Ir agora
								</button>
								{/* <button onClick={this.handleCancelRedirect}>Cancelar</button> */}
							</div>
						</div>
					</div>
				)}
			</StyledPage>
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			userLogin: userActions.login,
			setAccessToken: (accessToken) =>
				dispatch(userActions.setAccessToken(accessToken)),
			success: toastActions.success,
			warning: toastActions.warning,
			logout: userActions.logout,
		},
		dispatch
	)

const connectedRedefinePasswordPage = withRouter(
	connect(null, mapDispatchToProps)(RedefinePasswordPage)
)
export { connectedRedefinePasswordPage as ModuleRootComponent }
